export const headerSnykAuthFailed = 'snyk-auth-failed';
export const headerSnykTsCliTerminate = 'snyk-terminate';
